import { CentricTypography } from '@core/component/CentricTypography'
import classNames from 'classnames'
import { useObserver } from 'mobx-react-lite'
import React, { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core'
import IAReadOnlyField from './IAReadOnlyField'

interface IAProductSizesProps {
  rowData: any
  totalSizeQuantity: Number
  IATotalSizeQuantity: Number
  hasCaptureSize: boolean
  showProductSizes: boolean
  hideShowProductSizes: any
  sizesList: any
}

const useStyles = makeStyles(theme => ({
  sizeQuantitiesContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 'max-content',
    width: '100%'
  },
  showHideSizesBtn: {
    padding: 5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer'
  },
  productSizes: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  singleSize: {
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inactive: {
    opacity: '0.5'
  },
  totalSizeContainer: {
    height: 90,
    width: '100%'
  },
  lesserHeightSize: {
    height: 80
  },
  IASizeQtyFieldContainer: {
    height: 55
  }
}))

const IAProductSizes: FC<IAProductSizesProps> = ({
  rowData,
  totalSizeQuantity,
  IATotalSizeQuantity,
  hasCaptureSize,
  showProductSizes,
  hideShowProductSizes,
  sizesList
}) =>
  useObserver(function useHook() {
    const { t } = useTranslation()
    const classes = useStyles()

    const sizes = rowData?.['original-sizes-id'] || []
    const sizesElements = showProductSizes
      ? sizesList?.map(({ id, name, isInactive = false }) => {
          return (
            <div
              key={id}
              className={classNames(classes.singleSize, {
                [classes.inactive]: isInactive
              })}
            >
              <CentricTypography variant={'body1'}>{name}</CentricTypography>
            </div>
          )
        })
      : null

    if (!hasCaptureSize) {
      return null
    }

    return (
      <div className={classes.sizeQuantitiesContainer} key={rowData.id}>
        <div
          className={classNames(classes.totalSizeContainer, {
            [classes.lesserHeightSize]: showProductSizes
          })}
        >
          <IAReadOnlyField
            label={t('order.initialAllocation.totalIASizedQty', 'Total / IA Sized Qty')}
            value={`${totalSizeQuantity} / ${IATotalSizeQuantity}`}
            noBottomBorder={true}
            containerClass={classes.IASizeQtyFieldContainer}
          />
          {sizes?.length && hasCaptureSize ? (
            <div
              onClick={() => {
                hideShowProductSizes(!showProductSizes, rowData?.id)
              }}
              className={classes.showHideSizesBtn}
            >
              <CentricTypography variant='body2Blue'>
                {showProductSizes
                  ? `- ${t('orderTable.hideProductSizes', 'Hide Product Sizes')}`
                  : `+ ${t('orderTable.showProductSizes', 'Show Product Sizes')}`}
              </CentricTypography>
            </div>
          ) : null}
        </div>
        <div className={classes.productSizes}>{sizesElements}</div>
      </div>
    )
  })

export default memo(IAProductSizes)
